export default {
    namespaced: true,
    state:{
        payMoney:"预缴1000元起",
        applicantInfoList:[{
            personnelType:'1',
            name:'',
            certificateType:'01',
            certificateNo:'',
            mobile:''
        }]
    },
    getters:{
        policyIdType: state => {
            if (state.applicantInfoList[0].certificateType === '01'){
                return '身份证'
            } else {
                return '统一社会信用代码'
            }
        },
        policyName: state => {
            if (state.applicantInfoList[0].certificateType === '01'){
                return '姓名'
            } else {
                return '企业名称'
            }
        },
        showMoney: state => {
            if (state.payMoney === ''){
                return "1000起"
            } else {
                return state.payMoney
            }
        }
    },
    mutations:{
        setMoney(state,money){
            state.payMoney = money;
        },
        setPersonType(state,type){
            if (state.applicantInfoList[0].personnelType !== type){
                state.applicantInfoList[0].personnelType = type;
                if (type === '1'){
                    //个人
                    state.applicantInfoList[0].certificateType = '01';
                }else {
                    //团体
                    state.applicantInfoList[0].certificateType = '03';
                }
            }
        },
        setName(state,name){
            state.applicantInfoList[0].name = name.replace(/[• . .]/g, "·");
        },
        setCertificateNo(state,certificateNo){
            state.applicantInfoList[0].certificateNo = certificateNo;
        },
        setMobile(state,mobile){
            state.applicantInfoList[0].mobile = mobile;
        },
        setApplicantInfo(state, data) {
            state.applicantInfoList = data;
        }
    }
}